import { useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import { sortByAttribute } from '#utils/sorting';

export const GET_REPOSITORIES = gql`
  query GetRepositories($profileId: ID!, $status: RepositoryStatusEnum) {
    repositories(filterBy: {
      profileId: { eq: $profileId  },
      status: { eq: $status }
    }) {
      nodes {
        id
        name
        status
      }
    }
  }
`;

export const useRepositoriesQuery = ({ profileId, status = undefined }) => {
  const variables = { profileId, status };
  const { data, loading } = useQuery(GET_REPOSITORIES, { variables });
  const repositories = data?.repositories?.nodes;

  const sortedRepositories = useMemo(() => {
    if (!repositories) {
      return undefined;
    }
    return sortByAttribute(repositories, 'name');
  }, [repositories]);

  return { repositories: sortedRepositories, loading };
};
